import { Alert, AlertTitle, Box, Button, CardContent, Container, Typography, Card } from "@mui/material";
import {
	AccountCircle,
	ErrorOutline as ErrorOutlineIcon,
	Refresh as RefreshIcon
} from "@mui/icons-material";
import { useTheme } from "../../../contexts/ThemeContext";

export const ErrorState = ({ onRetry }) => {
	const { theme } = useTheme();

	return (
		<Box sx={{
			backgroundColor: theme.background.primary,
			minHeight: '-webkit-fill-available',
			p: 3,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center'
		}}>
			<Container maxWidth="md">
				<Card sx={{
					borderRadius: '16px',
					background: theme.background.tertiary,
					border: `1px solid ${theme.border.medium}`,
					textAlign: 'center',
					p: 4
				}}>
					<CardContent>
						<ErrorOutlineIcon
							sx={{
								fontSize: 80,
								color: theme.accent.error,
								mb: 2
							}}
						/>
						<Typography
							variant="h4"
							sx={{
								fontFamily: theme.fontFamily,
								color: theme.text.primary,
								fontWeight: 'bold',
								mb: 2
							}}
						>
							Unable to load your Dashboard
						</Typography>
						<Typography
							variant="body1"
							sx={{
								fontFamily: theme.fontFamily,
								color: theme.text.secondary,
								mb: 3,
								maxWidth: '500px',
								mx: 'auto'
							}}
						>
							We're having trouble loading your data. This could be due to a network issue or Walmart connection issue.
						</Typography>
						<Alert
							severity="error"
							sx={{
								mb: 3,
								textAlign: 'left',
								backgroundColor: `${theme.accent.error}15`,
								border: `1px solid ${theme.accent.error}30`,
								'& .MuiAlert-message': {
									fontFamily: theme.fontFamily,
									color: theme.text.primary
								},
								'& .MuiAlert-icon': {
									color: theme.accent.error
								}
							}}
						>
							<AlertTitle sx={{
								fontFamily: theme.fontFamily,
								color: theme.text.primary,
								fontWeight: 'bold'
							}}>
								Error
							</AlertTitle>
							Failed to fetch your data. Please try again or reconnect your Walmart account.
						</Alert>
						<Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
							<Button
								variant="outlined"
								startIcon={<RefreshIcon />}
								onClick={onRetry}
								sx={{
									fontFamily: theme.fontFamily,
									color: theme.text.primary,
									borderColor: theme.border.medium,
									borderRadius: '10px',
									px: 3,
									py: 1.5,
									textTransform: 'none',
									'&:hover': {
										borderColor: theme.color.primary,
										backgroundColor: `${theme.color.primary}10`
									}
								}}
							>
								Try Again
							</Button>
							<Button
								variant="outlined"
								startIcon={<AccountCircle />}
								onClick={() => window.location.href = "/account"}
								sx={{
									fontFamily: theme.fontFamily,
									color: theme.text.primary,
									borderColor: theme.border.medium,
									borderRadius: '10px',
									px: 3,
									py: 1.5,
									textTransform: 'none',
									'&:hover': {
										borderColor: theme.color.primary,
										backgroundColor: `${theme.color.primary}10`
									}
								}}
							>
								Reconnect your Walmart account
							</Button>
						</Box>
					</CardContent>
				</Card>
			</Container>
		</Box>
	)
};